import axios from 'axios';

// GrooveAPI → VideoPlayer.gg bridge. The browser never talks to the bridge or holds a Mux secret.
const NEEDS_CONNECT = ['not_connected', 'mux_unauthorized', 'mux_forbidden'];

export function muxError(error, fallback = 'Something went wrong with Mux. Please try again.') {
  const data = error && error.response && error.response.data;
  if (!data || typeof data !== 'object') {
    return { code: 'network', message: fallback, connectUrl: null, retryAfter: null, needsConnect: false };
  }
  const code = typeof data.error === 'string' ? data.error : 'unknown';
  return {
    code,
    message: typeof data.message === 'string' && data.message ? data.message : fallback,
    connectUrl: typeof data.connect_url === 'string' ? data.connect_url : null,
    retryAfter: Number(data.retry_after) || null,
    needsConnect: NEEDS_CONNECT.includes(code),
  };
}

export async function getMuxStatus() {
  const { data } = await axios.get('mux/status');
  return data.data;
}

export async function createMuxUpload(payload) {
  const { data } = await axios.post('mux/uploads', payload);
  return data.data;
}

export async function getMuxVideoStatus(id) {
  const { data } = await axios.get(`mux/videos/${id}/status`);
  return data.data;
}

export async function listMuxAssets(cursor) {
  const { data } = await axios.get('mux/assets', { params: cursor ? { cursor } : {} });
  return data.data;
}

// Server-side search of the owner's whole Mux library (VideoPlayer.gg keeps the index).
// `q` is a title or a pasted Mux asset/playback id; `cursor` is the previous page's next_cursor.
// Returns { items, next_cursor, index: { status, indexed_count } }.
export async function searchMuxAssets(q, cursor) {
  const params = {};
  const query = typeof q === 'string' ? q.trim() : '';
  if (query) params.q = query;
  if (cursor) params.cursor = cursor;
  const { data } = await axios.get('mux/assets/search', { params });
  return data.data;
}

export async function importMuxAsset(payload) {
  const { data } = await axios.post('mux/import', payload);
  return data.data;
}

// 204 for an ordinary delete; 200 with { data: { mux } } when a Mux deletion was requested.
export async function deleteVideo(id, { deleteFromMux = false } = {}) {
  const response = await axios.delete(`videos/${id}`, { params: deleteFromMux ? { delete_from_mux: 1 } : {} });
  const body = response && response.data;
  return (body && body.data && body.data.mux) || null;
}
